import {FormControl, FormHelperText, FormLabel} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {useFormContext, useWatch} from 'react-hook-form';
import FormErrors from 'src/view/shared/form/formErrors';
import FilesUploader from 'src/view/shared/uploaders/FilesUploader';
import FilesViewItem from 'src/view/shared/view/FilesViewItem';
import {DisabledItem} from './shared/formItemWrappers';

function FilesFormItem(props) {
  const {label, name, hint, storage, formats, max, required, externalErrorMessage, disabled} = props;

  const {
    register,
    formState: {touchedFields, isSubmitted, errors},
    setValue,
    control,
  } = useFormContext();

  useEffect(() => {
    register(name);
  }, []);

  const errorMessage = FormErrors.errorMessage(name, errors, touchedFields, isSubmitted, externalErrorMessage);

  const formHelperText = errorMessage || hint;

  const watchName: any = useWatch({name, control});

  if (disabled) {
    return (
      <DisabledItem
        label={label}
        show={watchName?.length > 0}
        noAnswerText="Sin documentos"
        item={<FilesViewItem value={watchName} />}
      />
    );
  }

  return (
    <FormControl fullWidth required={required} error={Boolean(errorMessage)} component="fieldset" size="small">
      <FormLabel component="legend">{label}</FormLabel>

      <FilesUploader
        storage={storage}
        formats={formats}
        value={watchName}
        onChange={(value) => {
          setValue(name, value, {
            shouldValidate: true,
          });
          props.onChange && props.onChange(value);
        }}
        max={max}
      />

      {formHelperText && <FormHelperText style={{marginTop: 0}}>{formHelperText}</FormHelperText>}
    </FormControl>
  );
}

FilesFormItem.defaultProps = {
  max: undefined,
  required: false,
};

FilesFormItem.propTypes = {
  storage: PropTypes.object.isRequired,
  formats: PropTypes.any,

  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  hint: PropTypes.string,
  formItemProps: PropTypes.object,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FilesFormItem;
